<script>
export default {
    wrong_password: `Le mot de passe saisi n'est pas correct.`,
    email_not_verified: `L'adresse e-mail n'est pas encore vérifiée. Si vous n'avez pas reçu l'e-mail, cliquez ici pour le renvoyer.`,
    model_saved: `Modèle enregistré avec succès.`,
    entry_Saved: `Entrée enregistrée avec succès.`,
    entry_updated: `Entrée mise à jour avec succès.`,
    generic_error: `Une erreur s'est produite. Veuillez réessayer plus tard.`,
    validation: {
        choose_Wallet: 'Veuillez choisir un compte portefeuille',
        choose_Category: 'Veuillez choisir une catégorie',
        insert_amount: 'Veuillez saisir une valeur pour le montant',
        choose_Wallet_transfer: 'Veuillez choisir un portefeuille différent pour le transfert',
        insert_payee: 'Veuillez saisir un nom de bénéficiaire',
        end_date_greater_than_start_date: 'La date de fin doit être postérieure à la date de début',
        choose_start_date: 'Veuillez choisir une date de début',
        end_date_greater_than_today: 'La date de fin doit être postérieure à aujourd\'hui',
        start_date_greater_than_today: 'La date de début doit être postérieure à aujourd\'hui',
        insert_model_name: 'Veuillez saisir un nom de modèle',
    },
    login: {
        not_verified_email: `L'adresse e-mail n'est pas encore vérifiée. Si vous n'avez pas reçu l'e-mail, cliquez ici pour le renvoyer.`,
        not_valid_password: `Le mot de passe saisi n'est pas correct.`,
    },
    wallet: {
        are_you_sure: 'Êtes-vous sûr de vouloir archiver ce portefeuille ?',
        archived: 'Portefeuille archivé',
        restored: 'Portefeuille restauré',
        saved: 'Portefeuille enregistré',
        wrong_Wallet: 'Veuillez choisir un type de portefeuille correct',
        wallet_name: 'Veuillez saisir un nom pour le portefeuille',
        wallet_currency: 'Veuillez choisir une devise pour le portefeuille',
        invoice_date: 'Veuillez choisir une date de facturation',
        closing_date: 'Veuillez choisir une date de clôture',
        payment_account: 'Veuillez choisir un compte de paiement',
        installment: 'Veuillez choisir une valeur de versement',
        voucher_value: 'Veuillez saisir une valeur du bon',
    },
    workspace: {
        updated: 'Espace de travail mis à jour',
        added: 'Espace de travail ajouté',
        user_not_fount: 'Utilisateur non trouvé',
        user_unshared: 'Utilisateur retiré de l\'espace de travail',
        confirm_delete: 'Êtes-vous sûr de vouloir supprimer cet espace de travail?',
        deleted: 'Espace de travail supprimé avec succès'
    },
    search: {
        no_results: 'Aucun résultat trouvé',
        please_set_date: 'Veuillez choisir une date de début et de fin',
    },
    delete_entry: 'Êtes-vous sûr de vouloir supprimer cette entrée ?',
    archive_debit: 'Êtes-vous sûr de vouloir archiver cette dette ?',
    we_are_loading_your_data: 'Nous chargeons vos données...',
    install: 'Installez notre application depuis le Play Store !',
    offline: 'Vous êtes hors ligne. Veuillez vérifier votre connexion internet.',
    chart: {
        no_data: 'Aucune donnée à afficher',
        no_data_selected: 'Aucune donnée sélectionnée',
    },
    label: {
        label_saved: 'Étiquette enregistrée avec succès',
        label_deleted: 'Étiquette supprimée avec succès',
        label_archived: 'Étiquette archivée avec succès',
        label_restored: 'Étiquette restaurée avec succès',
        label_name: 'Veuillez saisir un nom pour l\'étiquette',
        label_color: 'Veuillez choisir une couleur pour l\'étiquette',
        delete_label: 'Êtes-vous sûr de vouloir supprimer cette étiquette ?',
    },
    goal: {
        created: 'Objectif créé avec succès',
        error_creating: 'Erreur lors de la création de l\'objectif',
        updated: 'Objectif mis à jour avec succès',
        deleted: 'Objectif supprimé avec succès',
        confirm_delete_goal: 'Êtes-vous sûr de vouloir supprimer cet objectif ?'
    },
    date_required: 'Veuillez choisir une date',
    date_in_past: 'La date ne peut pas être dans le passé',
    amount_required: 'Veuillez saisir un montant valide',
    icon_required: 'Veuillez choisir une icône',
    name_required: 'Veuillez saisir un nom',
    manage_your_workspaces: 'Gérez vos espaces de travail',
}
</script>
